import React from 'react'

export default function Enzyme() {
  return (
    <section id="enzyme">
      <h1>Enzyme</h1>
      <p>L'utilitaire de TU créée par AirBnB pour faciliter le test des composants React.<br /><br />
      L'API fournit des méthodes pour monter les composants : <i>Shallow, Render, Mount</i>
      </p>
    </section>
  )
}
